import type { IconSvgObject } from './types';

const CommentRemove01Icon: IconSvgObject = [
  ["path", { d: "M21.9983 11.5V15.9971C21.9983 17.1016 21.1029 17.9971 19.9983 17.9971H11.499L7.58719 20.842C6.92623 21.3227 5.99902 20.8506 5.99902 20.0333V17.9971H4C2.89543 17.9971 2 17.1016 2 15.9971V4C2 2.89543 2.89543 2 4 2H12.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16.0012 2.00117L18.9994 5.00059M18.9994 5.00059L22 8M18.9994 5.00059L22 2M18.9994 5.00059L16 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8 13H14M8 8H10.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default CommentRemove01Icon;
